<!-- About us Start -->



<section class="section why-choose-us" id="about" style="background: #6320CE; background-size: cover;">

  <div class="svg-container">
    <svg viewBox="0 0 1440 127" fill="none" xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="719.5" cy="-95" rx="808.5" ry="222" fill="#FAF5FF" />
    </svg>
  </div>

  <div class="" style="width: 100%; display:flex;justify-content:center;">
    <!-- <div class="absolute">
      <img src="/assets/images/transition-pattern.png" class="img-responsive relative" />
    </div> -->
  </div>

  <div class="container">
    <div class="row justify-content-center team-container">
      <div class="col-lg-12">
        <div class="title text-center my-5">
          <h1 class="font-weight-normal text-white mb-5">Meet our Team</h1>

          <div class="container">
            <div class="row justify-content-center align-self-center" id="counter">
              <div class="col-lg-2 col-md-6 team-item">
                <div class="counter-box text-center text-white mb-4 mb-lg-0">
                  <figure><img src="/assets/images/ed-cyprian.jpg" class="img-responsive member-avatar avatar-image"
                      alt="Image Of Ed Cyprian" height="154px">
                  </figure>
                  <h3 class="member-name">Ed Cyprian</h3>
                  <h6 class="member-role">CEO</h6>
                </div>
              </div>



              <div class="col-lg-2 col-md-6 team-item pb-lg-5">
                <div class="counter-box text-center text-white mb-4 mb-lg-0">
                  <figure><img src="/assets/images/janis.png" class="img-responsive member-avatar avatar-image"
                      alt="Image Of Janis Santos" height="154px">
                  </figure>
                  <h3 class="member-name">Janis Santos</h3>
                  <h6 class="member-role">VP - Marketing</h6>
                </div>
              </div>

              <div class="col-lg-2 col-md-6 team-item">
                <div class="counter-box text-center text-white mb-4 mb-lg-0">
                  <figure><img src="/assets/images/erasmus-odametey.jpeg"
                      class="img-responsive member-avatar avatar-image" alt="Image Of Erasmus Odametey" height="154px">
                  </figure>
                  <h3 class="member-name">Erasmus Odametey</h3>
                  <h6 class="member-role">VP - Engineering</h6>
                </div>
              </div>

              <div class="col-lg-2 col-md-6 team-item">
                <div class="counter-box text-center text-white mb-4 mb-lg-0">
                  <figure><img src="/assets/images/gloria-asamoah.png" class="img-responsive member-avatar avatar-image"
                      alt="Image Of Gloria Asamoah" height="154px">
                  </figure>
                  <h3 class="member-name">Gloria Asamoah</h3>
                  <h6 class="member-role">VP - HR</h6>
                </div>
              </div>

              <div class="col-lg-2 col-md-6 team-item">
                <div class="counter-box text-center text-white mb-4 mb-lg-0">
                  <figure><img src="/assets/images/adam-kila.jpg" class="img-responsive member-avatar avatar-image"
                      alt="Image Of Adam Kila" height="154px">
                  </figure>
                  <h3 class="member-name">Adam Kila</h3>
                  <h6 class="member-role">CTO</h6>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="svg-container-2">
    <svg viewBox="0 0 1440 125" fill="none" xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="719.5" cy="222" rx="808.5" ry="222" fill="#34E3B2" />
    </svg>
  </div>
</section>
<!-- About us End -->
